var exports = {
  "k": "x9245d464--42acbd--container",
};

module.exports = exports;
